"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUsersApi = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = require("@reduxjs/toolkit/query/react");

var _objects = require("../utilities/objects");

var createUsersApi = function createUsersApi(baseApiPath) {
  return (0, _react.createApi)({
    reducerPath: baseApiPath.includes('v2') ? 'usersApiV2' : 'usersApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl: baseApiPath,
      prepareHeaders: function prepareHeaders(headers, _ref) {
        var _getState, _getState$user;

        var getState = _ref.getState;
        var token = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$user = _getState.user) === null || _getState$user === void 0 ? void 0 : _getState$user.accessToken;

        if (token) {
          headers.set('Authorization', "Bearer ".concat(token));
        }

        return headers;
      }
    }),
    endpoints: function endpoints(builder) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({
        changeEmail: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/users/change-email'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        changeEmailConfirm: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/users/auth/change-email-confirm'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        deleteUser: builder.mutation({
          query: function query(_ref2) {
            var body = _ref2.body,
                headers = _ref2.headers;
            return {
              body: body,
              credentials: 'include',
              headers: headers,
              method: 'DELETE',
              url: '/users'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        forgotPassword: builder.mutation({
          query: function query(_ref3) {
            var body = _ref3.body,
                headers = _ref3.headers;
            return {
              body: body,
              credentials: 'include',
              headers: headers,
              method: 'POST',
              url: '/users/auth/forget-password'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        getUser: builder.query({
          query: function query() {
            return {
              credentials: 'include',
              keepUnusedDataFor: 60 * 60 * 24,
              url: '/users'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        })
      }, baseApiPath.includes('v2') && {
        getUserInfo: builder.query({
          query: function query() {
            return {
              credentials: 'include',
              keepUnusedDataFor: 60 * 60 * 24,
              url: '/userinfo'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        })
      }), {}, {
        registerUser: builder.mutation({
          query: function query(_ref4) {
            var body = _ref4.body,
                headers = _ref4.headers;
            return {
              body: body,
              headers: headers,
              method: 'POST',
              url: '/users/auth/register'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        resetPassword: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/users/auth/reset-password'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        updatePassword: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/users/update-password'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        updateUser: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/users/update-profile'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        })
      });
    }
  });
};

exports.createUsersApi = createUsersApi;